import script from "./ManageModelsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageModelsView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageModelsView.vue?vue&type=style&index=0&id=44088fd7&lang=scss"

const __exports__ = script;

export default __exports__